'use client'

import { SALE_CONFIG } from '@/saleConfig'
import { tracking } from '@/tracking'
import { AdvertisingImageModalTrigger } from './AdvertisingImageModalTrigger'

const getSaleStorageKey = () => {
  const saleKey =
    SALE_CONFIG.saleName
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'sale'

  return `salePopupShown-${saleKey}`
}

export interface SummerSalePopupProps {
  placement: 'Homepage pop-up' | 'Product page pop-up'
  brandCode?: string
  productId?: number
  productName?: string
  productSlug?: string
}

const buildTrackingProperties = ({
  placement,
  brandCode,
  productId,
  productName,
  productSlug,
}: SummerSalePopupProps) => ({
  campaign: SALE_CONFIG.saleName,
  placement,
  brandCode,
  productId,
  productName,
  productSlug,
  destinationUrl: SALE_CONFIG.saleUrl,
})

export const SummerSalePopup = ({
  placement,
  brandCode,
  productId,
  productName,
  productSlug,
}: SummerSalePopupProps) => {
  if (!SALE_CONFIG.saleActive) {
    return null
  }

  const trackingProperties = buildTrackingProperties({
    placement,
    brandCode,
    productId,
    productName,
    productSlug,
  })

  return (
    <AdvertisingImageModalTrigger
      trigger="timer"
      triggerDelay={SALE_CONFIG.salePopupTriggerDelayMs}
      showOnce
      cookieName={getSaleStorageKey()}
      cookieExpireDays={SALE_CONFIG.salePopupStorageExpireDays}
      imageUrl={SALE_CONFIG.salePopupImageUrl}
      imageAlt={SALE_CONFIG.saleHeroImageAlt}
      href={SALE_CONFIG.saleUrl}
      label={`Shop the ${SALE_CONFIG.saleName}`}
      callbacks={{
        onModalShown: () => {
          tracking.track('Showed Summer Sale popup', trackingProperties)
        },
        onImageClick: () => {
          tracking.track('Clicked Summer Sale popup', trackingProperties)
        },
        onModalClose: () => {
          tracking.track('Closed Summer Sale popup', trackingProperties)
        },
      }}
    />
  )
}
